import { useParams } from "react-router";
import React from "react";
import PowerBiReportContainer from "../containers/PowerBiReportContainer";
import { useDataUnlessForbidden } from "../services/api";
import IProjectHeader from "../models/IProjectHeader";
import Loading from "../components/shared/Loading";
import { CircularProgress, Typography } from "@material-ui/core";
import HeroImage from "../assets/headers/rigCompressed.jpg";
import HeroArea from "../components/shared/BasePage/HeroArea";
import { ProjectVisibilityEnum } from "../enums/ProjectVisibilityEnum";
import PageContents from "../components/layouts/PageContents";
import { TRACER_VISION } from "../assets/Constants";
import { useStyles } from "../components/shared/Navigation";

const TracerVisionPage: React.FC = () => {
    const { projectId } = useParams();

    const [title, setTitle] = React.useState(TRACER_VISION);

    const [subtitle, setSubTitle] = React.useState(`Loading ${TRACER_VISION}`);

    const [project, isProjectLoading] = useDataUnlessForbidden<IProjectHeader>(
        "projects/" + projectId,
        () => {
            return (
                <HeroArea
                    imageUri={HeroImage}
                    title="Unable to access project"
                    subtitle="You have no access to view this project, please contact your Tracerco project manager."
                    variant="small"
                />
            );
        }
    );

    React.useEffect(() => {
        if (!isProjectLoading) {
            if (project) {
                if (
                    project?.projectVisibility ===
                    ProjectVisibilityEnum.PublishedToCustomer
                ) {
                    setTitle(TRACER_VISION);
                    setSubTitle(
                        `${TRACER_VISION} for project '${project.name}'`
                    );
                } else {
                    setTitle(heroTitle);
                    setSubTitle(heroSubTitle);
                }
            }
        }
    }, [project, isProjectLoading, setTitle, setSubTitle]);

    const heroTitle = `${TRACER_VISION} Not Available`;
    const heroSubTitle = `Sorry, there is no ${TRACER_VISION} report available for this project yet.`;
    const classes = useStyles();

    function showNoTracerVision() {
        return (
            <PageContents
                title={title}
                subtitle=""
                isForbidden={false}
                variant="small"
                maxWidth="xl"
            >
                <Typography
                    className={classes.noTracerVisionText}
                    variant="body1"
                    color="textSecondary"
                    component="p"
                    noWrap
                >
                    {heroSubTitle}
                </Typography>
            </PageContents>
        );
    }

    function showTracerVision() {
        return (
            <PageContents
                title={title}
                subtitle={subtitle}
                isForbidden={false}
                maxWidth="xl"
                variant="small"
            >
                {isProjectLoading ? (
                    <Loading>
                        <CircularProgress size={14} />
                    </Loading>
                ) : (
                    <PowerBiReportContainer
                        showComments={true}
                        projectId={parseInt(projectId!)}
                        reportName="tracervision"
                    />
                )}
            </PageContents>
        );
    }

    return (
        <React.Fragment>
            {project?.projectVisibility ===
            ProjectVisibilityEnum.PublishedToCustomer
                ? showTracerVision()
                : showNoTracerVision()}
        </React.Fragment>
    );
};

export default TracerVisionPage;
